const FooterBorder = () => {
  return (
    <div className="container position-relative">
      <div className="footer-border mt-3 pt-4 pb-0 px-0">
        <div className="row d-flex">
          <div className="col-md-6">
            <p className="mb-0">Copyright © 2024 HybridOps. All rights reserved | DevOps Services | AWS & GCP Certified</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterBorder;
